import { Box } from "@twilio-paste/core/box";
import React from "react";

export const SidebarNestedList: React.FC = (props) => (
    <Box as="ul" padding="space0" margin="space0" listStyleType="none" textTransform="capitalize">
        {props.children}
    </Box>
);
